import {
  DialogContent,
  Dialog,
  DialogProps,
  DialogActions,
  useEventCallback,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';
import { styled } from '@mui/styles';
import { useNavigate } from 'react-router';

export const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)((props) => ({
  '& .MuiDialog-paper': props.fullScreen
    ? {
        minWidth: 'unset',
        maxWidth: '100%',
      }
    : {
        minWidth: '50rem',
        maxWidth: '800px',
      },
}));

interface CancelModalProps {
  open: boolean;
  onClose: (open: boolean) => void;
}

const CancelModal = ({ open, onClose }: CancelModalProps): React.ReactElement => {
  const navigate = useNavigate();

  const onCancel = useEventCallback(() => {
    navigate('/sportello/rilascio-carta');
  });

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      open={open}
      onClose={() => onClose(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullScreen={fullScreen}
    >
      <PmiDialogTitle id="alert-dialog-title" backgroundColor="primary" color="white">
        Annulla operazione
      </PmiDialogTitle>
      <DialogContent style={{ padding: '30px 24px' }}>
        Annulla operazione comporta la perdita di tutti i dati digitati, si è sicuri di voler
        continuare?
      </DialogContent>
      <DialogActions>
        <PmiButton variant="contained" color="cdmBrand" type="button" onClick={onCancel}>
          Conferma Annullo
        </PmiButton>
        <PmiButton variant="outlined" color="primary" type="button" onClick={() => onClose(false)}>
          Chiudi
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

CancelModal.displayName = 'Modal cancel';

export default CancelModal;
